import { computed as computed_1, reaction as reaction_1, autorun as autorun_1, runInAction as runInAction_1, action as action_1, makeAutoObservable as makeAutoObservable_1, makeObservable as makeObservable_1, observable as observable_1 } from "mobx";

export const observable = observable_1;

export const makeObservable = makeObservable_1;

export const makeAutoObservable = makeAutoObservable_1;

export const action = action_1;

export const runInAction = runInAction_1;

export const autorun = autorun_1;

export const autorunOpt = autorun_1;

export const reaction = reaction_1;

export const reactionOpt = reaction_1;

export const computed = computed_1;

//# sourceMappingURL=MobX.fs.js.map
